(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["address-contact-form-ARES"] && !Shopify.designMode) return;
  try {
    
  var countrySelector = document.getElementById("AddressCountryNew");
  var provinces = countrySelector.options[countrySelector.selectedIndex].dataset.provinces;
  var parsedProvinces = JSON.parse(provinces);
  addProvince(parsedProvinces);

  countrySelector.onchange = function(event){
    var provinces = event.target.options[event.target.selectedIndex].dataset.provinces;
    var parsedProvinces = JSON.parse(provinces);
    addProvince(parsedProvinces);
  };

  function addProvince(provinces) {
    var provinceSelector = document.getElementById("AddressProvinceNew");
    provinceSelector.options.length = 0;
    provinces.forEach(province => {
      var option = document.createElement('option');
      option.value = province[0];
      option.innerHTML = province[0];
      provinceSelector.appendChild(option);
    })
  }

  
  

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["breadcrumbs-ARES"] && !Shopify.designMode) return;
  try {
    
  // const breadCrumbLinks = document.querySelectorAll(".breadcrumbs a")
  // const lastLink = breadCrumbLinks[breadCrumbLinks.length - 1]
  // lastLink.href = "/"

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["section-gallery-ARES"] && !Shopify.designMode) return;
  try {
    
var videos = document.getElementsByClassName("galleryVideo");
for (let i = 0; i < videos.length; i++){
  console.log("controls disabled");
  videos[i].controls = false; 
}

  } catch(e) { console.error(e); }
})();
})();
